import type { GetMeUserResponse } from "@nlc/shared-types";

import { USER_ROLES } from "@nlc/shared-types";
import { createFileRoute, redirect } from "@tanstack/react-router";

import TrashPage from "@/features/trash";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/trash/")({
  beforeLoad: async ({ context }) => {
    const userData = context.queryClient.getQueryData<GetMeUserResponse>([
      "user",
    ]);

    const permitedRoles = [
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.CUSTOMER_SUCCESS,
      USER_ROLES.TEAM_LEADER,
    ];

    if (!permitedRoles.includes(userData?.user.roleName as string)) {
      throw redirect({
        search: { filter: "all" },
        to: "/requests",
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Trash");

  return <TrashPage />;
}
